<div class="oauth-login-container">
  <button id="google-sign-in" type="button" (click)="signInWithGoogleClick()">
    <span class="icon"></span>
    <span class="buttonText">Sign in with Google</span>
  </button>
  <div class="enter-info">
    <hr class="bar" />
    <span class="enter-info-text">or enter your information</span>
    <hr class="bar" />
  </div>
</div>
